import { OnInit, Output, EventEmitter } from '@angular/core';
import { CommonService, SystemBusiness, FcsystemEvent } from 'fccore2';
import { FcModalConfig } from './business/fcmodel.business';
import { FcEvent } from './business/fcevent.event';
import { Fcomponent } from './f';
import { initAppData } from './business/fcapp';
export abstract class Fcgrand extends Fcomponent implements OnInit {
  EVENT: any;
  // ææç¶æ
  props: any;
  parentProps: any;
  /**
   * äºä»¶
   */
  @Output()
  fcEvent: EventEmitter<any> = new EventEmitter();
  /**
   * å½æ¨¡ååäº§åidå­å¨æ¶ï¼ååå§åç¸å³çåå®¹ï¼åå«æ¨¡åæè¿°ï¼æ¨¡åå¯¹åºçå±æ§åäºä»¶
   * @param pid äº§åid
   * @param aid æ¨¡åid
   */
  constructor(stateName: string, EVENT: any, mid?: string, aid?: string) {
    super();
    this.parentProps = SystemBusiness.store.getState();
    this.props = this.parentProps[stateName];
    // è®¢éäºä»¶çå¬ åå»ºStore
    this.pushDestroy(CommonService.subscribe(FcsystemEvent.storeStateGet, result => {
      this.parentProps = result.param;
      this.props = this.parentProps[stateName];
    }));
    this.EVENT = EVENT;
    let app = {};
    if (aid) {
      app = initAppData(aid);
      if (app === null) {
        this.pushDestroy(SystemBusiness.appService.findAppByAid(aid).subscribe(result => {
          if (result.CODE === '0') {
            SystemBusiness.appService.apps[aid] = result.DATA[aid];
            this.data = {...this.data, ...initAppData(aid)};
          }
        }));
      }
    }
    this.data = this.setData({mId: mid, appId: aid, ...app, ...this.initChildData(), ...this.initData()});
  }
  /**
   * åå§åå½åå¯¹è±¡åå®¹
   */
  ngOnInit() {
  }
  /**
   * åå§åå­ç±»çæ°æ®å¯¹è±¡
   * @param data åå§åæ°æ®å¯¹è±¡
   */
  abstract initChildData(): any;
  /**
   * åå§åå­å­ç±»çæ°æ®å¯¹è±¡
   * @param data åå§åæ°æ®å¯¹è±¡
   */
  abstract initData(): any;
  /**
   * èªå®ä¹äºä»¶åç§°ï¼ææèªå®ä¹äºä»¶çå¥å£
   * @param eventName äºä»¶åç§°
   * @param param åæ°
   */
  abstract event(eventName: string, param: any): void;
  /**
   * è·åç¡®è®¤å¼¹çªï¼éè¦ä¼ ç¹okåçåè°å½æ°åç¹åæ¶åçåè°å½æ°
   * @param content æç¤ºåå®¹
   * @param title æ é¢
   * @param ok ç¡®è®¤æ¹æ³
   * @param cancel åæ¶çæ¹æ³
   */
  confirm(content: string, title: string, ok: () => {}, cancel: () => {}): void {
    const modal: FcModalConfig = {
      title,
      content,
      okFunc: () => ok(),
      cancelFunc: () => cancel()
    };
    CommonService.event(FcEvent.fcmodal.confirm, modal);
    //  /** ParentBusiness.msgService.confirm(content, ok, cancel);*/
  }
  /**
   * é»æ­¢åæ³¡
   */
  stopPropagation(event: any): void {
    event.stopPropagation();
    event.preventDefault();
  }
}

/**
 * ä¿®æ¹å¯¹è±¡çè·åç­ç¥ï¼é»è®¤ä¸ºcacheæ¹å¼è·åæ°æ®ï¼asyncä¸ºä»è¿ç¨è·åæ°æ®æ¹å¼
 */
enum GetMainObjWay {
  'cache',
  'async'
}
